import { render, staticRenderFns } from "./account__form.vue?vue&type=template&id=5b8909aa"
import script from "./account__form.vue?vue&type=script&lang=js"
export * from "./account__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports